import Image from "next/image";
import { useAppSelector } from "../../../../../../redux/hooks";
import { conditions, secondsToPersianHMS } from "../../../../../../helpers";
import { ConditionName } from "../../../../../../interfaces";
import IMAGES from "../../../../../../images/importImages";
import ClockIcon from "../../../icon-components/clockIcon";
import { shallowEqual } from "react-redux";

const contentTypes = ["فیلم سینمایی", "سریال"];

const MovieDetail = () => {
    const { details, subtitles, multiAudio } = useAppSelector(
        ({ videoData: { details, subtitles, multiAudio, isComplexPortrait } }) => ({ details, subtitles, multiAudio, isComplexPortrait }),
        shallowEqual
    );
    const { duration } = useAppSelector(({ controller: { duration } }) => ({ duration }), shallowEqual);

    return (
        <div
            className={`pl-relative pl-flex ${
                conditions(ConditionName.isComplexPortrait) ? "pl-flex-col pl-gap-[14px]" : "pl-flex-row pl-items-center pl-gap-8 pl-mb-6"
            } ${
                !conditions(ConditionName.hasDescription) &&
                (conditions(ConditionName.isComplexPortrait)
                    ? "pl-border-b pl-border-secondary-500 pl-pb-4"
                    : "pl-border-b pl-border-secondary-300 dark:pl-border-gray-700 pl-pb-4")
            }`}
        >
            <div
                className={`pl-w-full pl-flex ${
                    conditions(ConditionName.isComplexPortrait) ? "pl-flex-col pl-gap-[14px]" : "pl-flex-row pl-items-center pl-gap-8"
                } pl-font-normal pl-text-gray-800 dark:pl-text-dark-5`}
            >
                <div className="pl-flex pl-items-center">
                    <div className="pl-ml-2 pl-flex pl-items-center">
                        <Image
                            src={conditions(ConditionName.isDarkMode) ? IMAGES.videoWhite : IMAGES.videoBlack}
                            alt="video-icon"
                            width={14}
                            height={14}
                        />
                    </div>
                    {conditions(ConditionName.hasMovieContentType) && <span className="pl-text-[13px]">{contentTypes[details.content_type!]}</span>}
                    {conditions(ConditionName.hasMovieContentType) && conditions(ConditionName.hasMovieReleaseYear) && (
                        <span className="pl-mx-1">.</span>
                    )}
                    {conditions(ConditionName.hasMovieReleaseYear) && <span className="pl-text-[14px]">{details.release_year}</span>}
                </div>
                <div className="pl-flex pl-items-center pl-gap-[9px] pl-text-[13px]">
                    <ClockIcon className="pl-fill-z-gray-500 dark:pl-fill-dark-5" />
                    {secondsToPersianHMS(duration).join(" و ")}
                </div>
                {conditions(ConditionName.hasSubtitle) && (
                    <div className="pl-flex pl-items-center pl-gap-[6px]">
                        <div className="pl-ml-[2px] pl-flex pl-items-center">
                            <Image
                                src={conditions(ConditionName.isDarkMode) ? IMAGES.subtitle1White : IMAGES.subtitle1Black}
                                alt="subtitle-icon"
                                width={14}
                                height={14}
                            />
                        </div>
                        <div className="pl-text-[14px] pl-font-normal pl-flex pl-items-center pl-gap-[2px]">
                            <span className="pl-text-dark-4 dark:pl-text-z-secondary-500">زیرنویس</span>
                            <span className="pl-text-gray-800 dark:pl-text-dark-5">:</span>
                        </div>
                        <div className="pl-flex pl-items-center pl-gap-3">
                            {subtitles.map((subtitle: any, index: number) => (
                                <p
                                    key={index}
                                    className="pl-text-[10px] pl-font-normal pl-text-gray-800 dark:pl-text-dark-5 pl-bg-secondary-300 dark:pl-bg-secondary-700 pl-px-[5px] pl-py-[3px] pl-rounded-[8px]"
                                >
                                    {subtitle.label}
                                </p>
                            ))}
                        </div>
                    </div>
                )}
                {conditions(ConditionName.hasMultiAudio) && (
                    <div className="pl-flex pl-items-center pl-gap-[6px]">
                        <div className="pl-ml-[2px] pl-flex pl-items-center">
                            <Image
                                src={conditions(ConditionName.isDarkMode) ? IMAGES.microphoneWhite : IMAGES.microphoneBlack}
                                alt="microphone-icon"
                                width={14}
                                height={14}
                            />
                        </div>
                        <div className="pl-text-[14px] pl-font-normal pl-flex pl-items-center pl-gap-[2px]">
                            <span className="pl-text-dark-4 dark:pl-text-z-secondary-500">دوبله</span>
                            <span className="pl-text-gray-800 dark:pl-text-dark-5">:</span>
                        </div>
                        <div className="pl-flex pl-items-center pl-gap-3">
                            {multiAudio.map((audio: any) => (
                                <p
                                    key={audio.lang}
                                    className="pl-text-[10px] pl-font-normal pl-text-gray-800 dark:pl-text-dark-5 pl-bg-secondary-300 dark:pl-bg-secondary-700 pl-px-[5px] pl-py-[3px] pl-rounded-[8px]"
                                >
                                    {audio.name}
                                </p>
                            ))}
                        </div>
                    </div>
                )}

                {conditions(ConditionName.hasIMDB) && (
                    <div
                        className={`pl-ml-3 pl-flex pl-items-center pl-mr-auto pl-bg-warning pl-pl-[11px] pl-rounded-[24px] pl-text-secondary-800 ${
                            conditions(ConditionName.isComplexPortrait) ? "pl-absolute pl-left-0" : "pl-relative"
                        }`}
                    >
                        <div className="pl-bg-orange-100/[0.4] pl-pr-4 pl-rounded-r-[24px] pl-pt-[2px] pl-pl-2 pl-text-[14px] pl-font-extrabold">
                            IMDB
                        </div>
                        <div className="pl-mr-[6px]">
                            <span className="pl-text-[15px] pl-font-bold">{details.imdb_rate}</span>
                            <span>/</span>
                            <span>10</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MovieDetail;
